/**
 * Create an AbortController for request cancellation
 */
export function createAbortController(): AbortController {
  return new AbortController()
}

/**
 * Check if a request is still active
 */
export function isRequestActive(
  currentRequestId: string | null | undefined,
  targetRequestId: string
): boolean {
  return currentRequestId === targetRequestId
}

/**
 * Merge streaming chunks into a single response
 */
export function mergeStreamChunks(chunks: string[]): string {
  return chunks.join('')
}

/**
 * Create a request ID for tracking streaming requests
 */
export function createRequestId(): string {
  return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
} 